/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import classes from './overview.module.scss'
import { useSelector } from "react-redux";
import { getENVData } from "../../constants/constantValue";
import { ProfileSvg } from "../../constants/resources";
var preState: any = ''
const Webflow = () => {
    const { UserProfile } = useSelector((state: any) => state.Question);
    const ENV = getENVData()
    const { getIdTokenClaims, isAuthenticated, user, isLoading } = useAuth0()
    const [profileModal, setProfileModal] = useState(false)
    const targetBlank = (key: any) => {
        if (window && key !== '') {
            if (key === 'viewer') {
                window.open(`${ENV.url}/viewer/`, '_blank');
            }
            else {
                window.open(`${ENV.url}/viewer/${key}`, '_blank');
                setProfileModal(false)
            }
        }
    }
    useEffect(() => {
        setInterval(() => {
            getIdTokenClaims()?.then((node: any) => {
                if (node) {
                    if (preState === '') {
                        preState = true;
                    }
                    if (preState === false) {
                        window.location.reload()
                    }
                } else {
                    if (preState === '') {
                        preState = false;
                    }
                    if (preState === true) {
                        window.location.reload()
                    }
                }
            })
        }, 2000);
    }, [])


    return <div>{isLoading ? <div className={classes.invalid}>
        <div className={classes.invalidbox}>
            <div className={classes.invalidtext}>
                <div className="lds-ring"><div></div><div></div><div></div><div></div></div> Loading
            </div>
        </div>
    </div> : <div className={classes.bg}>
        {isAuthenticated && !isLoading ?
            <div className={classes.successBlock}>
                <div className={classes.loginLogo}>
                    <div className={classes.name}>{UserProfile?.length > 0 && UserProfile.firstName ? UserProfile.firstName : user?.nickname}</div>
                    <div onClick={() => targetBlank('viewer')}><img alt="" className={classes.avatar} src={user?.picture} /></div>
                </div></div> :
            <div className={classes.successBlock}>
                <div onClick={() => setProfileModal(!profileModal)} className={classes.logoIcon}>
                    <ProfileSvg />
                </div>
            </div>}
    </div>}
        {(profileModal) && !isAuthenticated ?
            <div className={classes.WebFlowProfileModalMenu}>
                <div className={classes.ProfileMenuOption} onClick={() => targetBlank('login')} >Login</div>
                <div className={classes.ProfileMenuOption} onClick={() => targetBlank('signup')}
                >Sign Up</div>
            </div> : isAuthenticated &&
            <div className={classes.WebFlowLogOutModalMenu}>
                <div className={classes.ProfileMenuOption} onClick={() => targetBlank('signout')} >Logout</div>
            </div>}
    </div>
}
export default Webflow